import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'
import { useGetIntegrationIdentityConnectUrlMutation } from '@sketch/gql-types'
import { useToast } from '@sketch/toasts'

export const useGetIntegrationIdentityConnectUrl = () => {
  const { showToast } = useToast()
  const [isPersistentLoading, setIsPersistentLoading] = useState(false)

  // Handle page navigation via back/forward browser buttons
  // If the user clicks "Back" and the browser does not reload the page,
  // we want to stop showing the loading state
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        setIsPersistentLoading(false)
      }
    }

    window.addEventListener('pageshow', handlePageShow)

    return () => {
      window.removeEventListener('pageshow', handlePageShow)
    }
  }, [])

  const [getIntegrationIdentityConnectUrl] =
    useGetIntegrationIdentityConnectUrlMutation({
      onCompleted: data => {
        const { url } = data.getIntegrationIdentityConnectUrl

        window.location.href = url
      },
      onError: ({ message }) => {
        setIsPersistentLoading(false)
        showToast('Something went wrong', 'negative')

        Sentry.captureMessage(
          `Integration Identity Connect URL Error: ${message}`
        )
      },
    })

  const handleGetIntegrationIdentityConnectUrl = (
    ...args: Parameters<typeof getIntegrationIdentityConnectUrl>
  ) => {
    setIsPersistentLoading(true)

    return getIntegrationIdentityConnectUrl(...args)
  }

  return {
    getIntegrationIdentityConnectUrl: handleGetIntegrationIdentityConnectUrl,
    loading: isPersistentLoading,
  }
}
